import { controls,grouped } from "../controls";
const credit_notes = {
label: "Credit Notes",
pageLabel: "Credit Notes",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Purchase Order"}),
...controls.oc({ tab: "filter", c: "PurchaseOrder", placeHolder: "Purchase Order", name: "CreditNote-purchase_order-purchase_order",fastpath:"purchase_orders"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "CreditNote-purchase_order-purchase_order"}),
...controls.displayText({ tab: "filter", label: "Credit Note Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "credit_note_number",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Amount"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "amount",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Purchase Order",star:false}),
...controls.oc({ tab: "general", c: "PurchaseOrder", placeHolder: "Purchase Order", name: "purchase_order_code", isRequired:false,fastpath:"purchase_orders"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "purchase_order_display"}),
...controls.displayText({ tab: "general", label: "Credit Note Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "credit_note_number",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Credit Notes",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Purchase Order Code",accessor: "CreditNote-purchase_order-purchase_order_code",},
{Header: "Purchase Order",accessor: "CreditNote-purchase_order-purchase_order_display",},
{Header: "Credit Note Number",accessor: "credit_note_number",},
{Header: "Amount",accessor: "amount",},
]}};
export default credit_notes;